import { render, staticRenderFns } from "./PendenciesOpened.vue?vue&type=template&id=2f3170ff&scoped=true"
import script from "./PendenciesOpened.vue?vue&type=script&lang=js"
export * from "./PendenciesOpened.vue?vue&type=script&lang=js"
import style0 from "./PendenciesOpened.vue?vue&type=style&index=0&id=2f3170ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3170ff",
  null
  
)

export default component.exports